import { FC } from 'react';

import { LoginLayoutHeader } from '@gem/components';

import { ImageTheme } from 'APP/components/ImageTheme/ImageTheme';
import { UnauthorizedLayoutTemplate } from 'APP/components/UnauthorizedLayoutTemplate/UnauthorizedLayoutTemplate';

import { useDeepLinkErrorPresenter } from './DeepLinkError.presenter';
import styles from './DeepLinkError.styles.m.css';

interface IDeepLinkErrorProps {
  isExpired: boolean;
}

export const DeepLinkError: FC<IDeepLinkErrorProps> = ({ isExpired }) => {
  const presenter = useDeepLinkErrorPresenter({ isExpired });

  return (
    <UnauthorizedLayoutTemplate
      isShowLogo={false}
      subtitle={presenter.subtitle}
      header={
        <div className={styles.header}>
          <ImageTheme
            width={80}
            height={80}
            className={styles.image}
            darkImageName={'status-error-dark.png'}
            lightImageName={'status-error-light.png'}
          />
          <LoginLayoutHeader>{presenter.title}</LoginLayoutHeader>
        </div>
      }
    ></UnauthorizedLayoutTemplate>
  );
};
